/**
 *
 * ReceptionForm 14419
 *
 */
import React from 'react';
import AdvancedForm from 'containers/AdvancedForm';
import { formField } from 'domain/typeConstants/form';
import * as entity from 'domain/Data/constants';
import {
  CARRYING_OUT_WORKS,
  ON_CAR_ENTRY,
  ON_PROPERTY_BRINGING,
  ON_PROPERTY_REMOVAL, SERVICE, ON_VISIT,
} from 'domain/Data/RequestType/constants';
import { CREATED, ON_TERRITORY, REJECTED } from 'domain/Data/RequestStatus/constants';
import { PASSPORT } from 'domain/Data/DocumentType/constants';
import { validateCarNumber } from 'utils/validators';
import {
  carModelTextVisible,
  carNumberVisible,
  expirationDateVisible,
  longtermVisible,
  multipleEntryVisible,
  nonstandardCarNumberVisible,
  parkingDisabled, parkingCalculatedValue,
  typeHelperText, typeVisibleOptions,
  visitDateRowBreakBefore,
  companyNameLabel, companyNameVisible, companyNameRequired,
  factoryTimeLabel,
  carryInOrTakeawayMCV,
  fireWork,
  productionPersonnel,
  responsibilityForWork,
  responsibleForFireSafety,
  responsibleForSafetyAndHealth,
  shutdownEquipment,
  workPlace,
  workType,
  requestScan,
} from '../common/fields';
import { helperTextClassName } from '../common/formClassNames';
import { RECEPTION_REQUESTS_FORM } from 'pages/Requests/ReceptionView/constants';
import { getValueFromLocalStorage } from 'utils/localStorage';
import { GLOBAL_USER_KEY } from 'global-constants';
import { REQUESTS } from 'domain/Data/constants';
import { COMPANY_ARCHIVE_STATUS } from 'pages/Companies/ReceptionView/constants';
import { groupRequestVisitorsDataHelperText } from 'pages/Requests/common/fields';


export class ReceptionForm14419 extends React.PureComponent {

  getClassNames() {
    return {
      helperText: helperTextClassName,
    };
  }

  getFields() {
    const currentDate = new Date();

    return [
      {
        name: 'author',
        visible: false,
        initialValue: (values, mode, user) => user.id,
      },
      {
        name: 'number',
        label: '№',
        visible: (currentValues, initialValues, mode) => mode === 'edit',
        disabled: true,
      },
      {
        name: 'arrivalDate',
        type: 'date',
        visible: false,
        initialValue: () => null,
        calculatedValue: (values, mode) => mode === 'add' && values.type === ON_VISIT ? currentDate : null
      },
      {
        name: 'departureDate',
        visible: false,
        initialValue: () => null,
      },
      {
        name: 'status',
        type: formField.SELECT,
        label: 'Статус',
        entityName: entity.REQUEST_STATUSES,
        visible: (currentValues, initialValues, mode) => mode === 'edit',
        calculatedValue: (values, mode) => {
          if (mode === 'add' || mode === 'copy') { return CREATED; }

          return values.status;
        },
        visibleOptions: (currentValues, initialValues, mode, user, entities) => {
          const status = entities.get('requestStatuses').valueSeq().toJS();
          if (status && (currentValues.status === REJECTED || currentValues.status === CREATED)) {
            return status.filter(item => item.id !== ON_TERRITORY).map((item) => item.id);
          }
        },
        orderBy: 'name',
      },
      {
        name: 'type',
        type: formField.SELECT,
        label: 'Вид',
        required: true,
        entityName: entity.REQUEST_TYPES,
        initialValue: (values, mode) => {
          if (mode === 'add') {
            return ON_CAR_ENTRY;
          }
          return values.type;
        },
        orderBy: 'order',
        clearErrorsOnChange: true,
        helperText: typeHelperText,
        visibleOptions: typeVisibleOptions,
      },
      {
        name: 'longterm',
        type: formField.CHECKBOX,
        label: 'Долгосрочная',
        visible: longtermVisible,
      },
      {
        name: 'visitDate',
        type: formField.DATE,
        label: 'Дата',
        required: true,
        visible: true,
        initialValue: currentDate,
        min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
          new Date(initialValues.visitDate) : currentDate,
        rowBreakBefore: visitDateRowBreakBefore,
      },
      {
        name: 'expirationDate',
        type: formField.DATE,
        label: 'Дата окончания',
        required: (values) => values.longterm,
        visible: expirationDateVisible,
        initialValue: (values, mode) => {
          if (mode === 'copy') {
            return new Date(values.expirationDate) > currentDate ?
              new Date(values.expirationDate) : currentDate;
          }
          return null;
        },
        calculatedValue: (values) => values.longterm ? values.expirationDate : null,
        min: (values) => new Date(values.visitDate) < currentDate ?
          new Date(values.visitDate) : currentDate,
      },
      workType,
      {
        name: 'factoryTime',
        type: formField.SELECT,
        label: factoryTimeLabel,
        entityName: entity.TIMES,
        required: true,
        visible: (currentValues) => currentValues.type === ON_PROPERTY_BRINGING || currentValues.type === ON_PROPERTY_REMOVAL || currentValues.type === CARRYING_OUT_WORKS,
        helperText: (values) => {
          if (values.type === CARRYING_OUT_WORKS) {
            return 'Время проведения работ по правилам БП';
          }
          return null;
        },
      },
      {
        name: 'isGroupRequest',
        type: formField.CHECKBOX,
        label: 'Групповая заявка',
        visible: (values) => values.type === ON_CAR_ENTRY || values.type === CARRYING_OUT_WORKS,
        rowBreakBefore: true,
      },
      {
        name: 'nonstandardCarNumber',
        type: formField.CHECKBOX,
        label: 'Нестандартный № авто',
        rowBreakBefore: (values) => [ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL].includes(values.type),
        visible: nonstandardCarNumberVisible,
      },
      {
        name: 'multipleEntry',
        label: 'Многократный въезд',
        type: formField.CHECKBOX,
        visible: multipleEntryVisible,
      },
      {
        name: 'groupRequestVisitorsData',
        label: 'Список посетителей',
        multiline: true,
        helperText: groupRequestVisitorsDataHelperText(),
        visible: (values) => values.isGroupRequest,
        required: (values) => values.isGroupRequest,
        grid: { sm: 12 },
      },
      {
        name: 'visitorFullName',
        label: (values) => values.type === ON_CAR_ENTRY ? 'Гость/Посетитель/Подрядчик' : 'ФИО посетителя',
        type: formField.DADATA,
        dadataType: 'NAME',
        dadataParts: ['SURNAME', 'NAME', 'PATRONYMIC'],
        autoFocus: (currentValues, initialValues, mode) => mode === 'add',
        visible: (values) => !values.isGroupRequest && values.type !== CARRYING_OUT_WORKS,
        rowBreakBefore: (values) => !values.isGroupRequest,
      },
      {
        name: 'company',
        type: formField.AUTOCOMPLETE,
        label: 'Арендатор',
        entityName: entity.COMPANIES,
        filterBy: `!status.name.contains("${COMPANY_ARCHIVE_STATUS}") or (status = null)`,
        orderBy: 'name',
        numberInQueueFromEnd: 1,
        initialValue: (values, mode, user) => user.companyId,
        rowBreakAfter: (values) => values.type === ON_CAR_ENTRY,
        required: true,
      },
      {
        name: 'documentType',
        type: formField.SELECT,
        label: 'Вид документа',
        initialValue: PASSPORT,
        entityName: entity.DOCUMENT_TYPES,
        visible: (values) => (values.type !== ON_CAR_ENTRY && !values.isGroupRequest) && values.type !== CARRYING_OUT_WORKS,
        calculatedValue: (values) => values.isGroupRequest ? PASSPORT : values.documentType,
        rowBreakBefore: true,
      },
      {
        name: 'documentDetails',
        label: 'Серия, № документа',
        visible: (values) => (!values.isGroupRequest && values.type !== ON_CAR_ENTRY) && values.type !== CARRYING_OUT_WORKS,
      },
      {
        name: 'carNumber',
        label: '№ автомобиля',
        required: (values) => values.type === ON_CAR_ENTRY && !values.isGroupRequest,
        visible: carNumberVisible,
        normalize: (value) => value ? value.replace(' ', '') : value,
        validate: validateCarNumber,
        rowBreakBefore: true,
      },
      {
        name: 'carModelText',
        label: 'Марка автомобиля',
        visible: carModelTextVisible,
      },
      {
        name: 'parking',
        type: formField.SELECT,
        label: 'Парковка',
        entityName: entity.PARKINGS,
        visible: (values) => values.type !== ON_PROPERTY_REMOVAL &&
          values.type !== ON_PROPERTY_BRINGING && values.type === ON_CAR_ENTRY,
        rowBreakBefore: true,
        disabled: parkingDisabled,
        calculatedValue: parkingCalculatedValue,
      },
      {
        name: 'parkingPlace',
        label: '№ места',
        visible: (values) => values.type !== ON_PROPERTY_REMOVAL &&
          values.type !== ON_PROPERTY_BRINGING && values.type !== CARRYING_OUT_WORKS,
        initialValue: () => null,
      },
      {
        name: 'materialValuesData',
        label: 'Данные мат. ценностей',
        helperText: 'наименование, кол-во, ед.изм.',
        grid: { sm: 12 },
        required: true,
        visible: (values) => values.type === ON_PROPERTY_BRINGING ||
          values.type === ON_PROPERTY_REMOVAL,
      },
      {
        name: 'whatHappened',
        label: 'Наименование\\Характер работ',
        multiline: false,
        visible: (values) => values.type === CARRYING_OUT_WORKS,
        grid: { sm: 12 },
      },
      {
        name: 'companyName',
        label: companyNameLabel,
        visible: companyNameVisible,
        required: companyNameRequired,
      },
      {
        name: 'responsibleFromContractor',
        label: 'Ответственный от подрядчика',
        visible: (values) => values.type === CARRYING_OUT_WORKS,
        required: true,
        rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
      },
      {
        name: 'responsibleFromContractorPhone',
        label: 'Телефон отв. подрядчика',
        visible: (values) => values.type === CARRYING_OUT_WORKS,
        required: true,
      },
      {
        name: 'note',
        label: 'Примечание',
        grid: { sm: 12 },
        visible: () => true,
      },
      {
        name: 'managementCompanyComment',
        label: 'Комментарий УК',
        visible: (values, initialValues, mode) => mode === 'view' || mode === 'edit',
        grid: { sm: 12 },
        initialValue: (values, mode) => {
          if (mode === 'copy') {
            return null;
          }
          return values.managementCompanyComment;
        },
        required: (currentValues) => currentValues.status === REJECTED,
      },
      workPlace,
      {
        name: 'whereHappened',
        label: 'Где произошло',
        visible: (values) => values.type === SERVICE,
      },
      {
        name: 'implementationReport',
        label: 'Отчет о выполнении',
        visible: (values) => values.type === SERVICE,
        grid: { sm: 12 },
        calculatedValue: (values, mode) => {
          if (mode === 'copy') return null;
          return values.implementationReport;
        },
      },
      requestScan,
      {
        name: 'file',
        label: 'Договор подряда',
        type: formField.FILE,
        visible: (values) => values.type === CARRYING_OUT_WORKS,
        rowBreakBefore: true,
        helperText: 'Скан договора подряда',
      },
      responsibilityForWork,
      responsibleForSafetyAndHealth,
      responsibleForFireSafety,
      fireWork,
      shutdownEquipment,
      carryInOrTakeawayMCV,
      productionPersonnel,
    ];
  }


  render() {
    const accountId = getValueFromLocalStorage(GLOBAL_USER_KEY).accountId
    return (
      <AdvancedForm
        name={RECEPTION_REQUESTS_FORM}
        entityName={REQUESTS}
        classNames={this.getClassNames()}
        fields={this.getFields()}
        useAsyncValidate
        accountId={accountId}
        {...this.props}
      />
    );
  }

}

export default ReceptionForm14419